'use strict';

import SmartSearchbar from '../../molecules/smart-searchbar/smart-searchbar';

export default class FilmLandingBanner {
  constructor($selector, selfInit = true, config) {
    this.$selector = $selector;

    this.dataLayerModel = {
      event: "historyChange-v2",
      directoryKeyword: "",
      directoryMainFilter: "all",
      directoryMediaType: "all",
      directoryGenre: "all",
      directoryLanguage: "all",
      directoryYearType: "all",
      directoryStartYear: "all",
      directoryEndYear: "all",
      directoryAward: "all",
      directoryFilters: "all",
      directoryURL: ""
    }

    if(selfInit) this.init($selector, config);
  }

  init($selector, config) {
    this.pushDataLayer();
    this.setupSearchResultListener();
    this.$smartSearch = $('.smart-searchbar', $selector);
    this.smartSearchbar = new SmartSearchbar(this.$smartSearch, true, config);

    $('.btn-search', this.$smartSearch).on('click', () => {
      this.dataLayerModel.directoryURL = '';
      this.pushDataLayer();
      
      this.smartSearchbar.handleSearchSubmit();
    });

    $('.search-filters__input', this.$smartSearch).on('keyup', e => {
      e.preventDefault();
      if (e.keyCode == 13 || e.which == 13) {
        this.dataLayerModel.directoryURL = '';
        this.pushDataLayer();
        this.smartSearchbar.handleSearchSubmit();
      }
    });
  }

  pushDataLayer() {
    window.dataLayer = window.dataLayer || [];

    this.dataLayerModel.directoryKeyword = $('.search-filters__input', this.$smartSearch).val();

    this.dataLayerModel.directoryFilters = this.getFilterValues() ? this.getFilterValues() : "";

    //Set dataLayer 
    dataLayer.push(this.dataLayerModel);
  }

  getFilterValues() {
    return `${
      this.dataLayerModel.directoryKeyword ? this.dataLayerModel.directoryKeyword + "|" : "|"
    }${
      this.dataLayerModel.directoryMainFilter ? this.dataLayerModel.directoryMainFilter + "|" : ""
    }${
      this.dataLayerModel.directoryMediaType ? this.dataLayerModel.directoryMediaType + "|" : ""
    }${
      this.dataLayerModel.directoryGenre ? this.dataLayerModel.directoryGenre + "|" : ""
    }${
      this.dataLayerModel.directoryLanguage ? this.dataLayerModel.directoryLanguage + "|" : ""
    }${
      this.dataLayerModel.directoryYearType ? this.dataLayerModel.directoryYearType + "|" : ""
    }${
      this.dataLayerModel.directoryStartYear ? this.dataLayerModel.directoryStartYear + "|" : ""
    }${
      this.dataLayerModel.directoryEndYear ? this.dataLayerModel.directoryEndYear + "|" : ""
    }${
      this.dataLayerModel.directoryAward ? this.dataLayerModel.directoryAward + "|" : ""
    }${
      this.dataLayerModel.directoryURL ? this.dataLayerModel.directoryURL + "|" : ""
    }`;
  }

  setupSearchResultListener() {
    this.$selector.on('click', '.search-filters__suggestions a', (e) => {
      e.preventDefault();

      const dataUrl = $(e.currentTarget).closest("a").attr("href");
      const dataTarget = $(e.currentTarget).closest("a").attr("target");

      this.dataLayerModel.directoryURL = dataUrl;
      this.pushDataLayer();
      
      if (dataTarget == "_blank") {
        window.open(dataUrl, dataTarget);
      } else {
        window.open(dataUrl, "_self");
      }
    });
  }
}
